import React, { useContext, useEffect, useState } from 'react';
import { Input, Select, Button, Space, Table, Popconfirm, Tooltip, Switch, Modal, message, Empty, Form, Spin,} from 'antd';
import { MenuOutlined, DeleteOutlined, SaveOutlined, CheckOutlined, CloseOutlined, UndoOutlined} from '@ant-design/icons';
import { DndContext } from '@dnd-kit/core';
import {
	arrayMove,
	SortableContext,
	useSortable,
	verticalListSortingStrategy,
} from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import Cookies from 'js-cookie';
import constants from '../../constants/constants';
import APIUtils from '../../api/APIUtils';
import WebLinks from '../../api/WebLinks';
import { GetCustomPriorityLevelIcons, GetPriorityLevelColors, trackPageAccess } from '../../globalFunctions/GlobalFunctions';
import { CommonContext } from '../../Context';


// Drag & Drop Stuff
const Row = ({ children, ...props }) => {
	const {
		attributes,
		listeners,
		setNodeRef,
		setActivatorNodeRef,
		transform,
		transition,
		isDragging,
	} = useSortable({
		id: props['data-row-key'],
	});
	const style = {
		...props.style,
		transform: CSS.Transform.toString(
			transform && {
				...transform,
				scaleY: 1,
			},
		)?.replace(/translate3d\(([^,]+),/, 'translate3d(0,'),
		transition,
		...(isDragging
			? {
				position: 'relative',
				zIndex: 9999,
			}
			: {}),
	};
	return (
		<tr {...props} ref={setNodeRef} style={style} {...attributes}>
			{React.Children.map(children, (child) => {
				if (child.key === 'sort') {
					return React.cloneElement(child, {
						children: (
							<MenuOutlined
								ref={setActivatorNodeRef}
								style={{
									touchAction: 'none',
									cursor: 'move',
								}}
								{...listeners}
							/>
						),
					});
				}
				return child;
			})}
		</tr>
	);
};
const { Option } = Select;

const MultiPriorityFilters = () => {
	// Data
	const commonContext=useContext(CommonContext);
  const buyerId = commonContext.common.buyerId;
	const [dataSource, setDataSource] = useState([]);
	const [loader, setLoader] = useState(false);
	const [count, setCount] = useState(dataSource.length);
	const [isAddPriorityOpen, setIsAddPriorityOpen] = useState(false);
	const [isOrderChanged, setIsOrderChanged] = useState(false);
	const [form] = Form.useForm();
	const [dynamicForm] = Form.useForm();
	const [priorityColorCode,setPriorityColorCode]=useState([]);

	// Table Columns
	const columns = [
		{
			key: 'sort',
			width: '5%'
		},
		{
			title: 'Filter',
			dataIndex: 'filter',
			render: (_,record) =>
			<Form form={dynamicForm}>{filterForm(true,record)}</Form>,
		},
		{
			title: 'operation',
			dataIndex: 'operation',
			width: '7%',
			className:'relative',
			render: (_, record) =>
			<>
				<span className='absolute top-2 font-bold whitespace-nowrap'>{record.id!=0?"ID: "+record.id:null}</span>
				{dataSource.length >= 1 ? (
					<Space direction='vertical'>
						{record.isUpdated?(
							<>
								<Tooltip title="Save" placement='top'>
										<Button icon={<SaveOutlined />} type="link" size='large' onClick={()=>(saveFilterData(record))} />
								</Tooltip>
								<Tooltip title="Undo" placement='top'>
										<Button icon={<UndoOutlined />} type="link" size='large' onClick={()=>(undoFilterChange(record))} />
								</Tooltip>
							</>
						):null}
						<Tooltip title="Delete Priority" placement='bottom'>
							<Popconfirm title="Sure you want to delete this filter?" onConfirm={() => handleDelete(record)}  placement="left">
								<Button icon={<DeleteOutlined />} type="link" danger size='large' />
							</Popconfirm>
						</Tooltip>
					</Space>
				) : null}
		</>
		},
	];
	// Delete Priority Filters Row
	const handleDelete = async(filter) => {
		setLoader(true);
		const deleteResponse = await APIUtils.apiCall("DELETE",WebLinks.DeletePriorityFilter+filter.id);
		if(deleteResponse.isCatch || deleteResponse?.resultObj?.statusCode!=='2000'){
			message.error( deleteResponse?.resultObj?.message || constants.ERROR_MESSAGE);
		}else{
			const newData = dataSource.filter((item) => item.key !== filter.key);
			setDataSource(newData);
		}
		
		setLoader(false);
	};
 //Function to get priority list
 const getBuyerPrioritylist=async()=>{
	let url = WebLinks.GetBuyerPriorityFilters + buyerId;    
	const response = await APIUtils.apiCall('GET', url);
	if (!response.isCatch && response.resultObj) {
		let temppriorityColorCode=[];
		response?.resultObj?.data.forEach(element => {
			let priorityObj={
				value:element.priorityLevel,
				colorValue:response?.resultObj?.data?.length>5?GetCustomPriorityLevelIcons(element.priorityLevel):GetPriorityLevelColors(element.priorityLevel),
				customName:element.customName,
			}
			temppriorityColorCode.push(priorityObj);
			setPriorityColorCode(temppriorityColorCode);
		});
	} else {
		setPriorityColorCode([]);
		message.error(response?.resultObj?.message);
	}
};
	// Add New filter
	const addFilter = async(newFilter) => {
		setLoader(true);
		const addResponse = await APIUtils.apiCall("POST",WebLinks.AddPriorityFilter,JSON.stringify(newFilter));

		if(addResponse.isCatch || addResponse?.resultObj?.statusCode!=='2000'){
			message.error( addResponse?.resultObj?.message || constants.ERROR_MESSAGE);
		}else{
			newFilter.id=addResponse?.resultObj?.priorityFilterId;
			setDataSource([...dataSource, newFilter]);
			setCount(count + 1);
			setIsAddPriorityOpen(false);
			form.resetFields();
		}
		setLoader(false);
  	};
	const handleOk = (e) => {
		if(e.jobText || e.locationText || e.descriptionText){
			let newfilter={
				id:0,
				buyerId:buyerId,
				key:count + 1,
				isUpdated:false,
				filterOrder: dataSource.length + 1,
				titleFilterText: e.jobText || "",
				locationFilterText: e.locationText || "",
				priorityLevel: e.priorityLevel,
				titleFilterType: e.jobTitleType || "",
				locationFilterType: e.locationType ||"",
				isLive: e.live===undefined?true:e.live,
				changedLive: e.live===undefined?true:e.live,
				descriptionFilterText: e.descriptionText || "",
				UpdatedByBuyerId:Cookies.get(constants.COOKIE_LOGGED_BUYER_ID)
			}
			addFilter(newfilter);
		}else{
 			message.error(constants.PRIORITY_FILTER_TEXT_ERROR);
		}	
	};
	const handleCancel = () => {
		form.resetFields();
		setIsAddPriorityOpen(false);
	};
	// Drag & Drop Stuff
	const onDragEnd = ({ active, over }) => {
		if(!isOrderChanged){setIsOrderChanged(true)}
		if (active.id !== over?.id) {
			setDataSource((previous) => {
				const activeIndex = previous.findIndex((i) => i.key === active.id);
				const overIndex = previous.findIndex((i) => i.key === over?.id);
				return arrayMove(previous, activeIndex, overIndex);
			});
		}
	};
	const getData =async()=>{
		setLoader(true);
		const res =await APIUtils.apiCall("GET",WebLinks.GetPriorityFilters+buyerId,null);
		if(res.isCatch || res?.resultObj?.statusCode!=='2000'){
			message.error( res?.resultObj?.message || constants.ERROR_MESSAGE);
			setLoader(false);
		}else{
			const modifiedData= res?.resultObj?.data?.map((item,index)=>({key:index+1,isUpdated:false,changedLive:item.isLive, ...item,}));
			setDataSource(modifiedData || []);
			setCount(modifiedData?.length || 0)
			setLoader(false);
		}
	}
	const getRowColor = (record) =>{
		if(record.locationFilterType!=="" && record.titleFilterType!==""){
			return"teal-tr"
		}else if(record.locationFilterType!==""){
			return"yellow-tr"
		}else{
			return"purple-tr"
		}
	}
	const buildOrderpayload = () =>{
		const Filterlist= dataSource;
		return Filterlist.map((item,index)=>{item.filterOrder=index+1;return item;});
	}
	const handleSaveOrder = async() =>{
		setLoader(true);
		const payload = await buildOrderpayload();
		const addResponse = await APIUtils.apiCall("PUT",WebLinks.UpdateOrderPriorityFilter,JSON.stringify(payload));
		if(addResponse.isCatch || addResponse?.resultObj?.statusCode!=='2000'){
			message.error( addResponse?.resultObj?.message || constants.ERROR_MESSAGE);
		}else{
			message.success(addResponse?.resultObj?.message);
			setIsOrderChanged(false);
		}
		setLoader(false);
	}
	const setFilterAsUpdated = (record,isSaved=false) =>{
		const modifiedList=dataSource.map((item)=>{
			if(item.key===record.key){
				item.isUpdated=isSaved?false:true;
			}
			return item;
		})
		setDataSource(modifiedList);
	};
	const saveFilterData = async (record) =>{
		setLoader(true);
		const formValues= dynamicForm.getFieldsValue();
		if(formValues['jobText-'+record.key]?.trim() || formValues['locationText-'+record.key]?.trim() || formValues['descriptionText-'+record.key]?.trim()){
			let updateFilter={
			id:record.id,
			buyerId:record.buyerId,
			key:record.key,
			isUpdated:false,
			filterOrder: record.filterOrder,
			titleFilterText: formValues['jobText-'+record.key],
			titleFilterType: formValues['jobTitleType-'+record.key],
			locationFilterText: formValues['locationText-'+record.key],
			descriptionFilterText: formValues['descriptionText-'+record.key],
			locationFilterType: formValues['locationType-'+record.key],
			priorityLevel: formValues['priorityLevel-'+record.key],
			isLive: formValues['live-'+record.key]===undefined?record.isLive:formValues['live-'+record.key],
			UpdatedByBuyerId:Cookies.get(constants.COOKIE_LOGGED_BUYER_ID)
		}
		const addResponse = await APIUtils.apiCall("PUT",WebLinks.UpdatePriorityFilter,JSON.stringify(updateFilter));
		if(addResponse.isCatch || addResponse?.resultObj?.statusCode!=='2000'){
			message.error( addResponse?.resultObj?.message || constants.ERROR_MESSAGE);
		}else{
			message.success(addResponse?.resultObj?.message);
			setFilterAsUpdated(record,true);
		}
		}else{
			message.error(constants.PRIORITY_FILTER_TEXT_ERROR);
	 	}
		setLoader(false);
	};
	const undoFilterChange = (record) =>{
		setLoader(true);
		dynamicForm.setFieldsValue({ ['jobText-'+record.key] : record.titleFilterText,
		['jobTitleType-'+record.key]:record.titleFilterType,
		['locationText-'+record.key]:record.locationFilterText,
		['descriptionText-'+record.key]:record.descriptionFilterText,
		['locationType-'+record.key]:record.locationFilterType,
		['priorityLevel-'+record.key]:record.priorityLevel,
		// ['live-'+record.key]:record.isLive
		});
		setLiveValue(record,true);
		setLoader(false);
	};
	const getFieldName= (name,update,record=null) =>{
		return update?name+'-'+record?.key || 0:name;
	}
	const setLiveValue = (record,reset=false) =>{
		setFilterAsUpdated(record,reset);
		let list=dataSource.map((item)=>{
			if(item.key===record.key){
				item.changedLive=reset?item.isLive : !item.changedLive;
			}
			return item;
		});
		setDataSource(list);
	};
	const filterForm = (update = false, record=null) =>{
		const jobTitleOptions = [
			{
				value: 'Equals',
				label: 'Equals',
			},
			{
				value: 'Contains',
				label: 'Contains',
			},
		];
		// const priorityLevelOptions = [
		// 	{
		// 		value: 0,
		// 		label: (
		// 			<Space>
		// 				<div className="w-3.5 h-3.5 border rounded-full border-black bg-white"></div>
		// 				Organic
		// 			</Space>
		// 		),
		// 	},
		// 	{
		// 		value: 1,
		// 		label: (
		// 			<Space>
		// 				<div className="w-3.5 h-3.5 border rounded-full border-black bg-lime-400"></div>
		// 				Standard
		// 			</Space>
		// 		),
		// 	},
		// 	{
		// 		value: 2,
		// 		label: (
		// 			<Space>
		// 				<div className="w-3.5 h-3.5 border rounded-full border-black bg-orange-400"></div>
		// 				Extra
		// 			</Space>
		// 		),
		// 	},
		// 	{
		// 		value: 3,
		// 		label: (
		// 			<Space>
		// 				<div className="w-3.5 h-3.5 border rounded-full border-black bg-red-600"></div>
		// 				Max + Social
		// 			</Space>
		// 		),
		// 	},
		// 	{
		// 		value: 4,
		// 		label: (
		// 			<Space>
		// 				<div className="w-3.5 h-3.5 border rounded-full border-black bg-purple-600"></div>
		// 				Critical + Social
		// 			</Space>
		// 		),
		// 	},
		// ];
		return(
				
				<table className='w-full priority-list'>
					<colgroup>
						<col width="10%" />
						<col width="20%" />
						<col width="35%" />
						<col width="20%" />
					</colgroup>
					<thead>
						<tr className='uppercase font-bold text-left'>
							<th></th>
							<th>Conditions</th>
							<th>Filter text</th>
							<th>Priority</th>
						</tr>
					</thead>
					<tbody>
						
						<tr>
							<td className='text-right uppercase font-bold'>
								If Job Title
							</td>
							<td>
								<Form.Item name={getFieldName('jobTitleType',update,record)} className='!mb-0' initialValue={update?record.titleFilterType:null}>
									<Select
										allowClear
										className='w-full'
										options={jobTitleOptions}
										onChange={()=>(update?setFilterAsUpdated(record):null)}
									/>
								</Form.Item>
							</td>
							<td>
							<Form.Item name={getFieldName('jobText',update,record)} dependencies={[getFieldName('jobTitleType',update,record)]} hasFeedback className='!mb-0'
							rules={[
								({ getFieldValue }) => ({
								validator(_, value) {
									if ((getFieldValue(getFieldName('jobTitleType',update,record)) && value) || (!getFieldValue(getFieldName('jobTitleType',update,record)) && !value)) {
									return Promise.resolve();
									}
									return Promise.reject(new Error('Enter the Location title filter type and text.'));
								},
								}),
							]}
							initialValue={update?record.titleFilterText:null}><Input onChange={()=>(update?setFilterAsUpdated(record):null)}/></Form.Item>
							</td>
							<td>
							<Form.Item name={getFieldName('priorityLevel',update,record)} className='!mb-0'
								rules={[
									{
										required: true,
										message: 'Enter priority level.',
									},]}
									initialValue={update?record.priorityLevel:null}
							>
								<Select
									onChange={()=>(update?setFilterAsUpdated(record):null)}
									allowClear
									className='w-full'
									// options={priorityLevelOptions}
								>
									{priorityColorCode?.map((item=>{
										return(
										<Option value={item.value}>
												<Space>
													<div className={item.colorValue}></div>
													{item.customName}
												</Space>             
										</Option>
										)
									}))}
								</Select>
							</Form.Item>
							</td>
						</tr>
						<tr>
							<td className='text-right uppercase font-bold'>
							IF DESCRIPTION
							</td>
							<td>
							<Form.Item name={getFieldName('descriptionType',update,record)} className='!mb-0' >
								<Select
									className='w-full select-readonly'
									options={jobTitleOptions}	
									defaultValue={"Contains"}	
									disabled				
								/>
							</Form.Item>
							</td>
							<td>
							<Form.Item name={getFieldName('descriptionText',update,record)} className='!mb-0'  
							// rules={[
							// 	({ getFieldValue }) => ({
							// 	validator(_, value) {
							// 		if ((getFieldValue(getFieldName('locationType',update,record)) && value) || (!getFieldValue(getFieldName('locationType',update,record)) && !value)) {
							// 		return Promise.resolve();
							// 		}
							// 		return Promise.reject(new Error('Enter the Location title filter type and text .'));
							// 	},
							// 	}),
							// ]} 
							initialValue={update?record.descriptionFilterText:null}><Input onChange={()=>(update?setFilterAsUpdated(record):null)}/></Form.Item>
							</td>
							<td>
							</td>
						</tr>
						<tr>
							<td className='text-right uppercase font-bold'>
								If Location
							</td>
							<td>
							<Form.Item name={getFieldName('locationType',update,record)} className='!mb-0' initialValue={update?record.locationFilterType:null}>
								<Select
									onChange={()=>(update?setFilterAsUpdated(record):null)}
									allowClear
									className='w-full'
									options={jobTitleOptions}
								/>
							</Form.Item>
							</td>
							<td>
							<Form.Item name={getFieldName('locationText',update,record)} className='!mb-0' dependencies={[getFieldName('locationType',update,record)]} hasFeedback 
							rules={[
								({ getFieldValue }) => ({
								validator(_, value) {
									if ((getFieldValue(getFieldName('locationType',update,record)) && value) || (!getFieldValue(getFieldName('locationType',update,record)) && !value)) {
									return Promise.resolve();
									}
									return Promise.reject(new Error('Enter the Location title filter type and text .'));
								},
								}),
							]} initialValue={update?record.locationFilterText:null}><Input onChange={()=>(update?setFilterAsUpdated(record):null)}/></Form.Item>
							</td>
							<td>
								<div className='uppercase font-bold'>
									<Space>
										Sync to Live
										<Form.Item name={getFieldName('live',update,record)} className='!mb-0'>
											<Switch
												onChange={()=>(update?setLiveValue(record):null)}
												checked={update?record?.changedLive:true}
												checkedChildren={<CheckOutlined />}
												unCheckedChildren={<CloseOutlined />}
											/>
											{/* <Checkbox defaultChecked={update?record?.isLive:true}/> */}
										</Form.Item>
									</Space>
								</div>
							</td>
						</tr>
					</tbody>
				</table>
		)
	};
	useEffect(()=>{
		getBuyerPrioritylist();
		getData();
		trackPageAccess(buyerId,window.location.href)
	},[]);
	return (
		<div>
			<Spin spinning={loader}>
				<div className='flex justify-between items-center'>
					<div className='uppercase font-bold text-xl'>Master Priority Filter</div>
					{/* Add new row button */}
					{/* <Button size="large" type='primary' onClick={handleAdd}>
						{constants.CreateNew}
					</Button> */}
					<Space>
						<Button hidden={!isOrderChanged} size="large" type='primary' onClick={()=>handleSaveOrder()}>
							{constants.SaveOrder}
						</Button>
						<Button size="large" type='primary' onClick={()=>setIsAddPriorityOpen(true)}>
							{constants.CreateNew}
						</Button>
					</Space>
				</div>
				{/* Draggable rows Priority filter list start. */}
				<div className='mt-3 overflow-x-auto grid gap-y-4'>
				{/* p-3 border rounded-md border-l-8 border-teal-500, border-secondary, border-violet-500 */}
					{dataSource.length>0?(
						<DndContext onDragEnd={onDragEnd}>
							<SortableContext
								// rowKey array
								items={dataSource.map((i) => i.key)}
								strategy={verticalListSortingStrategy}
							>
								<Table
									components={{
										body: {
											row: Row,
										},
									}}
									rowKey="key"
									columns={columns}
									dataSource={dataSource}
									showHeader={false}
									// pagination={false}
									pagination={
										dataSource.length>50?
										{
											defaultPageSize:'50',
											pageSizeOptions: ['50', '75', '100'],
										}:false
									}
									size="small"
									className='priority-table'
									rowClassName={(record,index)=>(getRowColor(record))} /* yellow-tr, purple-tr */
								/>
							</SortableContext>
						</DndContext>
					):<Empty description={"You currently have no filters."}/>}
				</div>
				{/* Priority Popup */}
				<Modal 
					title={constants.PriorityPopup} 
					open={isAddPriorityOpen} 
					onOk={()=>form.submit()} 
					onCancel={()=>handleCancel()}
					okText={<span className="capitalize">Create</span>}
					cancelText={<span className="capitalize">Reset</span>}
					cancelButtonProps={{disabled:loader}}
					width={1000}
					confirmLoading={loader}
				>
					<Form onFinish={handleOk} form={form}>
						{filterForm()}
					</Form>
					
				</Modal>
	  		</Spin>
		</div>
	);
};

export default MultiPriorityFilters;